import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PasswordUpdateComponent } from './password-update.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { KIconModule } from 'ng-k-icon';
import { KButtonModule } from 'ng-k-button';
import { KDataVisualizationModule } from 'ng-k-data-visualization';
import { KModalModule } from 'ng-k-modal';
import { KNotificationsModule } from 'ng-k-notifications';



@NgModule({
  declarations: [PasswordUpdateComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    KIconModule,
    KButtonModule,
    KDataVisualizationModule,
    KNotificationsModule
  ],
  exports: [PasswordUpdateComponent]

})
export class PasswordUpdateModule { }
